export const CONTACT = {
  whatsapp: "+569 3560 9185",
  whatsappLink: "https://wa.me/56935609185",
  email: "contacto@devoluzion.com",
  instagram: "https://www.instagram.com/devoluzion/",
  facebook: "https://www.facebook.com/profile.php?id=61592628959822",
  linkedin: "https://www.linkedin.com/company/dev-inc-latam/",
  youtube: "https://www.youtube.com/@devoluzion",
  tiktok: "https://www.tiktok.com/@devoluzion",
};

export const copy = {
  es: {
    topbar: {
      text: "Descubre cómo la inteligencia artificial puede mejorar tus procesos",
      cta: "Agendar",
    },
    nav: {
      process: "Proceso",
      services: "Servicios",
      marketing: "Marketing",
      cases: "Casos",
      contact: "Contacto",
      cta: "Iniciar evolución",
    },
    hero: {
      kicker: "AGENCIA DE TRANSFORMACIÓN DIGITAL",
      line1: "Tu negocio",
      line2: "puede evolucionar.",
      sub: "Diseñamos experiencias digitales, software, automatizaciones e inteligencia artificial que convierten tecnología en crecimiento, combinando marketing digital, SEO y Google Ads para atraer clientes y generar nuevas oportunidades.",
      cta1: "Iniciar mi evolución",
      cta2: "Ver lo que hacemos",
      scroll: "Desliza para evolucionar",
    },
    chapters: [
      {
        num: "01",
        label: "LA IDEA",
        title: "Todo comienza con una idea.",
        sub: "La convertimos en una experiencia digital diseñada para crecer.",
        chips: [],
      },
      {
        num: "02",
        label: "DISEÑO UX/UI",
        title: "Diseñamos experiencias que las personas quieren usar.",
        sub: "Estrategia, investigación y sistemas de diseño que convierten visitas en intención.",
        chips: ["UX", "UI", "STRATEGY", "BRANDING", "CONVERSION"],
      },
      {
        num: "03",
        label: "DESARROLLO",
        title: "Construimos tecnología desde dentro.",
        sub: "Ingeniería limpia, escalable y segura. Cada componente, en su lugar exacto.",
        chips: ["CODE", "API", "DATABASE", "CLOUD", "SECURITY", "RESPONSIVE", "SEO"],
      },
      {
        num: "04",
        label: "ECOMMERCE",
        title: "De visitas a clientes.",
        sub: "Creamos experiencias de comercio digital pensadas para vender.",
        chips: ["CONVERSION RATE ↑", "REVENUE ↑", "ORDERS ↑", "ROAS ↑"],
      },
      {
        num: "05",
        label: "AUTOMATIZACIÓN",
        title: "Tu negocio trabajando aunque tú no estés.",
        sub: "Conectamos procesos, datos y herramientas para eliminar trabajo manual y aumentar eficiencia.",
        chips: ["CRM", "EMAIL", "WHATSAPP", "ERP", "ADS", "ANALYTICS"],
      },
      {
        num: "06",
        label: "INTELIGENCIA ARTIFICIAL",
        title: "IA aplicada al negocio.",
        sub: "No implementamos inteligencia artificial porque esté de moda. La utilizamos donde genera impacto real.",
        chips: ["AI AGENTS", "LEAD SCORING", "FORECASTING", "PERSONALIZATION", "INSIGHTS"],
      },
      {
        num: "07",
        label: "DATA",
        title: "Lo que no se mide, no evoluciona.",
        sub: "Cada decisión respaldada por datos en tiempo real.",
        chips: ["VISITORS", "CONVERSION", "CAC", "LTV", "REVENUE", "ROAS"],
      },
      {
        num: "08",
        label: "GROWTH",
        title: "Y entonces ocurre lo importante.",
        sub: "",
        chips: [],
        stats: [
          { value: "+38%", label: "Conversión" },
          { value: "+127%", label: "Leads" },
          { value: "+84%", label: "Revenue" },
          { value: "6.4x", label: "ROAS" },
        ],
        statsNote: "*Métricas ilustrativas de demostración",
        big: "GROWTH.",
      },
    ],
    finale: {
      line1: "TU NEGOCIO.",
      line2: "PERO EVOLUCIONADO.",
      cta: "Comenzar mi evolución",
    },
    services: {
      kicker: "QUÉ HACEMOS",
      title: "Nueve disciplinas.",
      title2: "Una evolución.",
      sub: "Cada servicio responde a una pregunta: qué hacemos, cómo lo hacemos, por qué es diferente y qué resultado genera.",
      items: [
        { num: "01", title: "Estrategia Digital", desc: "Auditoría, roadmap y arquitectura de crecimiento. Definimos hacia dónde evolucionar antes de escribir una línea de código.", tags: ["AUDIT", "ROADMAP", "KPIs"] },
        { num: "02", title: "Diseño UX/UI", desc: "Interfaces premium centradas en las personas. Investigación, prototipos y sistemas de diseño que convierten.", tags: ["UX", "UI", "DESIGN SYSTEM"] },
        { num: "03", title: "Desarrollo Web", desc: "Sitios y aplicaciones rápidas, seguras y escalables. Código limpio, performance obsesiva y SEO técnico.", tags: ["REACT", "NEXT.JS", "SEO"] },
        { num: "04", title: "Ecommerce", desc: "Tiendas diseñadas para vender: catálogo, checkout sin fricción, pagos y analítica en tiempo real.", tags: ["CHECKOUT", "PAGOS", "CRO"] },
        { num: "05", title: "Software a Medida", desc: "Plataformas, ERPs y herramientas internas que eliminan cuellos de botella operativos.", tags: ["API", "CLOUD", "INTEGRACIONES"] },
        { num: "06", title: "Automatización", desc: "Conectamos CRM, email, WhatsApp y tus sistemas para que el negocio opere sin trabajo manual.", tags: ["CRM", "WHATSAPP", "WORKFLOWS"] },
        { num: "07", title: "Inteligencia Artificial", desc: "Agentes, lead scoring, forecasting y personalización aplicados donde generan impacto medible.", tags: ["AGENTES", "ML", "PREDICCIÓN"] },
        { num: "08", title: "Growth", desc: "Adquisición, experimentación y optimización continua basada en datos.", tags: ["ADS", "CRO", "ANALÍTICA"] },
        { num: "09", title: "Marketing Digital & Ads", desc: "SEO y campañas en Google, Meta, LinkedIn y TikTok optimizadas por IA. Adquisición medible, no métricas de vanidad.", tags: ["SEO", "GOOGLE", "META", "LINKEDIN", "TIKTOK"] },
      ],
    },
    marketing: {
      kicker: "IA + MARKETING DIGITAL",
      title: "Tu marca,",
      title2: "amplificada por datos.",
      sub: "Combinamos inteligencia artificial, pauta publicitaria y SEO para que cada peso invertido vuelva multiplicado. Campañas que aprenden solas y presupuestos que se optimizan en tiempo real.",
      robotCaption: "UNIDAD IA — DVL-01",
      robotAlt: "Unidad de inteligencia artificial de DEVOLUZION, robot humanoide blanco",
      platforms: [
        { name: "SEO", desc: "Posicionamiento orgánico técnico y de contenidos para capturar demanda real en Google." },
        { name: "Google Ads", desc: "Search, Shopping y Performance Max con pujas optimizadas por IA." },
        { name: "Meta Ads", desc: "Instagram y Facebook: creatividades que convierten, no solo acumulan likes." },
        { name: "LinkedIn Ads", desc: "Adquisición B2B con segmentación por cargo, industria e intención de compra." },
        { name: "TikTok Ads", desc: "Alcance masivo y audiencias nuevas con video nativo de alto rendimiento." },
      ],
    },
    marquee: ["EVOLUCIÓN DIGITAL", "ESTRATEGIA", "DISEÑO", "DESARROLLO", "ECOMMERCE", "AUTOMATIZACIÓN", "IA", "DATA", "GROWTH"],
    cases: {
      kicker: "CASOS",
      title: "No hablamos de transformación.",
      title2: "La construimos.",
      demoBadge: "PROYECTO DEMOSTRATIVO",
      fields: { company: "Empresa", problem: "Problema", solution: "Solución", tech: "Tecnología", result: "Resultado" },
      items: [
        {
          company: "ANDES SUPPLY",
          title: "Ecommerce B2B que vende solo",
          problem: "Ventas gestionadas por WhatsApp y planillas, sin trazabilidad ni catálogo digital.",
          solution: "Plataforma ecommerce B2B con catálogo vivo, precios por cliente y automatización completa de pedidos.",
          tech: "Aplicada a la empresa para generar tráfico y growth",
          result: "+127% pedidos online en 90 días",
          image: "/assets/cases/caso-ecommerce-b2b-andes-supply-1600.webp",
          imageSrcSet: "/assets/cases/caso-ecommerce-b2b-andes-supply-640.webp 640w, /assets/cases/caso-ecommerce-b2b-andes-supply-1024.webp 1024w, /assets/cases/caso-ecommerce-b2b-andes-supply-1600.webp 1600w",
          alt: "Pago digital en terminal, ecommerce premium",
        },
        {
          company: "NÓMADA HOTELS",
          title: "Reservas directas sin comisiones",
          problem: "Dependencia total de OTAs con comisiones superiores al 20% por reserva.",
          solution: "Motor de reservas directo con diseño cinematográfico y pricing dinámico asistido por IA.",
          tech: "Aplicada a la empresa para generar tráfico y growth",
          result: "+64% reservas directas en 6 meses",
          image: "/assets/cases/caso-reservas-directas-nomada-hotels-1600.webp",
          imageSrcSet: "/assets/cases/caso-reservas-directas-nomada-hotels-640.webp 640w, /assets/cases/caso-reservas-directas-nomada-hotels-1024.webp 1024w, /assets/cases/caso-reservas-directas-nomada-hotels-1600.webp 1600w",
          alt: "Aplicación móvil premium sobre superficie oscura",
        },
        {
          company: "KUDO FINANCE",
          title: "Decisiones con datos, no intuición",
          problem: "Información dispersa en seis herramientas; reportes manuales de días completos.",
          solution: "Dashboard unificado con forecasting, alertas automáticas y métricas en tiempo real.",
          tech: "Aplicada a la empresa para generar tráfico y growth",
          result: "−40% tiempo de análisis semanal",
          image: "/assets/cases/caso-dashboard-analytics-kudo-finance-1600.webp",
          imageSrcSet: "/assets/cases/caso-dashboard-analytics-kudo-finance-640.webp 640w, /assets/cases/caso-dashboard-analytics-kudo-finance-1024.webp 1024w, /assets/cases/caso-dashboard-analytics-kudo-finance-1600.webp 1600w",
          alt: "Dashboard analítico oscuro con gráficos",
        },
      ],
    },
    contact: {
      kicker: "CONTACTO",
      title: "¿Listo para",
      title2: "evolucionar?",
      sub: "Cuéntanos dónde está tu negocio hoy y hacia dónde quieres llevarlo. Respondemos en menos de 24 horas.",
      name: "Nombre",
      namePh: "Tu nombre",
      email: "Email",
      emailPh: "tu@empresa.com",
      company: "Empresa (opcional)",
      companyPh: "Nombre de tu empresa",
      message: "Mensaje",
      messagePh: "Quiero transformar mi negocio…",
      submit: "Enviar mensaje",
      sending: "Enviando…",
      success: "Mensaje recibido. Tu evolución ya comenzó.",
      error: "No pudimos enviar tu mensaje. Inténtalo de nuevo o escríbenos por WhatsApp.",
      whatsappCta: "Hablar por WhatsApp",
      emailLabel: "Email",
      socialLabel: "Síguenos",
    },
    footer: {
      tagline: "No hacemos páginas web. Construimos evolución digital.",
      chile: "Talento chileno. Tecnología que hace crecer Chile.",
      guarantee: "Si no te gusta la experiencia, te devolvemos el 100%.",
      rights: "Todos los derechos reservados.",
      menu: "Menú",
      social: "Social",
      locations: "Ubicaciones",
      cities: ["La Serena", "Santiago", "Concepción"],
    },
  },
  en: {
    topbar: {
      text: "Discover how artificial intelligence can improve your processes",
      cta: "Book a call",
    },
    nav: {
      process: "Process",
      services: "Services",
      marketing: "Marketing",
      cases: "Work",
      contact: "Contact",
      cta: "Start evolving",
    },
    hero: {
      kicker: "DIGITAL TRANSFORMATION AGENCY",
      line1: "Your business",
      line2: "can evolve.",
      sub: "We design digital experiences, software, automations and artificial intelligence that turn technology into growth, combining digital marketing, SEO and Google Ads to attract clients and generate new opportunities.",
      cta1: "Start my evolution",
      cta2: "See what we do",
      scroll: "Scroll to evolve",
    },
    chapters: [
      {
        num: "01",
        label: "THE IDEA",
        title: "Everything starts with an idea.",
        sub: "We turn it into a digital experience designed to grow.",
        chips: [],
      },
      {
        num: "02",
        label: "UX/UI DESIGN",
        title: "We design experiences people want to use.",
        sub: "Strategy, research and design systems that turn visits into intent.",
        chips: ["UX", "UI", "STRATEGY", "BRANDING", "CONVERSION"],
      },
      {
        num: "03",
        label: "DEVELOPMENT",
        title: "We build technology from the inside out.",
        sub: "Clean, scalable, secure engineering. Every component in its exact place.",
        chips: ["CODE", "API", "DATABASE", "CLOUD", "SECURITY", "RESPONSIVE", "SEO"],
      },
      {
        num: "04",
        label: "ECOMMERCE",
        title: "From visits to customers.",
        sub: "We craft digital commerce experiences built to sell.",
        chips: ["CONVERSION RATE ↑", "REVENUE ↑", "ORDERS ↑", "ROAS ↑"],
      },
      {
        num: "05",
        label: "AUTOMATION",
        title: "Your business working even when you're not.",
        sub: "We connect processes, data and tools to remove manual work and increase efficiency.",
        chips: ["CRM", "EMAIL", "WHATSAPP", "ERP", "ADS", "ANALYTICS"],
      },
      {
        num: "06",
        label: "ARTIFICIAL INTELLIGENCE",
        title: "AI applied to business.",
        sub: "We don't implement AI because it's trendy. We use it where it creates real impact.",
        chips: ["AI AGENTS", "LEAD SCORING", "FORECASTING", "PERSONALIZATION", "INSIGHTS"],
      },
      {
        num: "07",
        label: "DATA",
        title: "What isn't measured, doesn't evolve.",
        sub: "Every decision backed by real-time data.",
        chips: ["VISITORS", "CONVERSION", "CAC", "LTV", "REVENUE", "ROAS"],
      },
      {
        num: "08",
        label: "GROWTH",
        title: "And then the important part happens.",
        sub: "",
        chips: [],
        stats: [
          { value: "+38%", label: "Conversion" },
          { value: "+127%", label: "Leads" },
          { value: "+84%", label: "Revenue" },
          { value: "6.4x", label: "ROAS" },
        ],
        statsNote: "*Illustrative demo metrics",
        big: "GROWTH.",
      },
    ],
    finale: {
      line1: "YOUR BUSINESS.",
      line2: "BUT EVOLVED.",
      cta: "Start my evolution",
    },
    services: {
      kicker: "WHAT WE DO",
      title: "Nine disciplines.",
      title2: "One evolution.",
      sub: "Every service answers a question: what we do, how we do it, why it's different and what result it generates.",
      items: [
        { num: "01", title: "Digital Strategy", desc: "Audit, roadmap and growth architecture. We define where to evolve before writing a single line of code.", tags: ["AUDIT", "ROADMAP", "KPIs"] },
        { num: "02", title: "UX/UI Design", desc: "Premium, human-centered interfaces. Research, prototypes and design systems that convert.", tags: ["UX", "UI", "DESIGN SYSTEM"] },
        { num: "03", title: "Web Development", desc: "Fast, secure, scalable sites and apps. Clean code, obsessive performance and technical SEO.", tags: ["REACT", "NEXT.JS", "SEO"] },
        { num: "04", title: "Ecommerce", desc: "Stores designed to sell: catalog, frictionless checkout, payments and real-time analytics.", tags: ["CHECKOUT", "PAYMENTS", "CRO"] },
        { num: "05", title: "Custom Software", desc: "Platforms, ERPs and internal tools that remove operational bottlenecks.", tags: ["API", "CLOUD", "INTEGRATIONS"] },
        { num: "06", title: "Automation", desc: "We connect CRM, email, WhatsApp and your systems so the business runs without manual work.", tags: ["CRM", "WHATSAPP", "WORKFLOWS"] },
        { num: "07", title: "Artificial Intelligence", desc: "Agents, lead scoring, forecasting and personalization applied where they generate measurable impact.", tags: ["AGENTS", "ML", "PREDICTION"] },
        { num: "08", title: "Growth", desc: "Acquisition, experimentation and continuous, data-driven optimization.", tags: ["ADS", "CRO", "ANALYTICS"] },
        { num: "09", title: "Digital Marketing & Ads", desc: "SEO and campaigns on Google, Meta, LinkedIn and TikTok, optimized by AI. Measurable acquisition, not vanity metrics.", tags: ["SEO", "GOOGLE", "META", "LINKEDIN", "TIKTOK"] },
      ],
    },
    marketing: {
      kicker: "AI + DIGITAL MARKETING",
      title: "Your brand,",
      title2: "amplified by data.",
      sub: "We combine artificial intelligence, paid media and SEO so every dollar invested comes back multiplied. Campaigns that learn on their own and budgets that optimize in real time.",
      robotCaption: "AI UNIT — DVL-01",
      robotAlt: "DEVOLUZION artificial intelligence unit, white humanoid robot",
      platforms: [
        { name: "SEO", desc: "Technical and content-driven organic rankings to capture real demand on Google." },
        { name: "Google Ads", desc: "Search, Shopping and Performance Max with AI-optimized bidding." },
        { name: "Meta Ads", desc: "Instagram and Facebook: creatives that convert, not just collect likes." },
        { name: "LinkedIn Ads", desc: "B2B acquisition with targeting by role, industry and purchase intent." },
        { name: "TikTok Ads", desc: "Massive reach and new audiences through high-performing native video." },
      ],
    },
    marquee: ["DIGITAL EVOLUTION", "STRATEGY", "DESIGN", "DEVELOPMENT", "ECOMMERCE", "AUTOMATION", "AI", "DATA", "GROWTH"],
    cases: {
      kicker: "WORK",
      title: "We don't talk about transformation.",
      title2: "We build it.",
      demoBadge: "DEMONSTRATION PROJECT",
      fields: { company: "Company", problem: "Problem", solution: "Solution", tech: "Technology", result: "Result" },
      items: [
        {
          company: "ANDES SUPPLY",
          title: "A B2B ecommerce that sells itself",
          problem: "Sales managed through WhatsApp and spreadsheets, with no traceability or digital catalog.",
          solution: "B2B ecommerce platform with a living catalog, per-client pricing and fully automated ordering.",
          tech: "Applied to the business to drive traffic and growth",
          result: "+127% online orders in 90 days",
          image: "/assets/cases/caso-ecommerce-b2b-andes-supply-1600.webp",
          imageSrcSet: "/assets/cases/caso-ecommerce-b2b-andes-supply-640.webp 640w, /assets/cases/caso-ecommerce-b2b-andes-supply-1024.webp 1024w, /assets/cases/caso-ecommerce-b2b-andes-supply-1600.webp 1600w",
          alt: "Digital payment on a terminal, premium ecommerce",
        },
        {
          company: "NÓMADA HOTELS",
          title: "Direct bookings, zero commissions",
          problem: "Total dependence on OTAs charging over 20% commission per booking.",
          solution: "Direct booking engine with cinematic design and AI-assisted dynamic pricing.",
          tech: "Applied to the business to drive traffic and growth",
          result: "+64% direct bookings in 6 months",
          image: "/assets/cases/caso-reservas-directas-nomada-hotels-1600.webp",
          imageSrcSet: "/assets/cases/caso-reservas-directas-nomada-hotels-640.webp 640w, /assets/cases/caso-reservas-directas-nomada-hotels-1024.webp 1024w, /assets/cases/caso-reservas-directas-nomada-hotels-1600.webp 1600w",
          alt: "Premium mobile app on a dark surface",
        },
        {
          company: "KUDO FINANCE",
          title: "Decisions with data, not intuition",
          problem: "Information scattered across six tools; manual reports taking full days.",
          solution: "Unified dashboard with forecasting, automated alerts and real-time metrics.",
          tech: "Applied to the business to drive traffic and growth",
          result: "−40% weekly analysis time",
          image: "/assets/cases/caso-dashboard-analytics-kudo-finance-1600.webp",
          imageSrcSet: "/assets/cases/caso-dashboard-analytics-kudo-finance-640.webp 640w, /assets/cases/caso-dashboard-analytics-kudo-finance-1024.webp 1024w, /assets/cases/caso-dashboard-analytics-kudo-finance-1600.webp 1600w",
          alt: "Dark analytics dashboard with charts",
        },
      ],
    },
    contact: {
      kicker: "CONTACT",
      title: "Ready to",
      title2: "evolve?",
      sub: "Tell us where your business is today and where you want to take it. We reply within 24 hours.",
      name: "Name",
      namePh: "Your name",
      email: "Email",
      emailPh: "you@company.com",
      company: "Company (optional)",
      companyPh: "Your company's name",
      message: "Message",
      messagePh: "I want to transform my business…",
      submit: "Send message",
      sending: "Sending…",
      success: "Message received. Your evolution has already begun.",
      error: "We couldn't send your message. Try again or reach us on WhatsApp.",
      whatsappCta: "Chat on WhatsApp",
      emailLabel: "Email",
      socialLabel: "Follow us",
    },
    footer: {
      tagline: "We don't make websites. We build digital evolution.",
      chile: "Chilean talent. Technology that grows Chile.",
      guarantee: "If you don't love the experience, we refund 100%.",
      rights: "All rights reserved.",
      menu: "Menu",
      social: "Social",
      locations: "Locations",
      cities: ["La Serena", "Santiago", "Concepción"],
    },
  },
};
